import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { AppQueryParams, AppSections } from '../../constants';
import { useApplicationParams, useLanguage } from '../../context';

const CustomModal = ({
  className,
  icon,
  description,
  action = false,
  onHide,
  text,
  isLiveRoomsSection,
  ...props
}) => {
  const { isWeb, userToken } = useApplicationParams();
  const { isRtl } = useLanguage();

  const goToHomepage = () => {
    const queryParams = new URLSearchParams();

    if (!isWeb) {
      queryParams.set(AppQueryParams.UserToken, userToken);
    }

    if (isLiveRoomsSection) {
      queryParams.set(AppQueryParams.AppSection, AppSections.LiveRoom);

      const inAppRedirectQueryParams = new URLSearchParams({
        [AppQueryParams.AppSection]: AppSections.LiveRoom,
        [AppQueryParams.OngoingTransaction]: 'false',
        [AppQueryParams.DismissShop]: 'true',
        to: encodeURIComponent(`/shop?${queryParams.toString()}`),
      });

      window.open(`/in-app-redirect?${inAppRedirectQueryParams.toString()}`, '_self');
    } else {
      window.open(`/shop${queryParams.size > 0 ? '?' + queryParams.toString() : ''}`, '_self');
    }
  };

  return (
    <Modal
      {...props}
      className={`modal ${className}`}
      aria-labelled="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="modal-img">{icon}</div>
        <div className="modal-desc">{description}</div>
      </Modal.Body>
      {!!text && (
        <Modal.Footer>
          <Button className={isRtl && 'mt-4'} onClick={action ? goToHomepage : onHide}>
            {text}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
